module.exports = __webpack_public_path__ + "img/Diwali 2.1af874cc.jpeg";